import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d50375f")

_pushScopeId("data-v-4d50375f")
const _hoisted_1 = { class: "autocomplete" }
const _hoisted_2 = {
  key: 0,
  class: "options-list"
}
_popScopeId()

import { ref, computed, withDefaults, watch } from 'vue';
import PadelInput from '@/widgets/input/PadelInput.vue';
import vClickOutside from '@/directives/click-outside'; // Corrected: Import directly

interface Option {
  label: string;
  value: string | boolean | null;
}

interface Props {
  modelValue?: string | boolean | null;
  options: Option[];
  label?: string;
  filterable?: boolean;
}


export default _defineComponent({
  props: {
    modelValue: { type: [String, Boolean, null], required: false, default: '' },
    options: { type: Array, required: true, default: () => [] },
    label: { type: String, required: false, default: '' },
    filterable: { type: Boolean, required: false }
  } as unknown as undefined,
  emits: ["update:modelValue"] as unknown as undefined,
  setup(__props: {
  modelValue?: string | boolean | null;
  options: Option[];
  label?: string;
  filterable?: boolean;
}, { emit }: { emit: ({
  (e: 'update:modelValue', value: string | boolean | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const open = ref(false);
const internalSearchQuery = ref<string>(props.options.find(option => option.value === props.modelValue)?.label || '');

watch(() => props.modelValue, (newValue) => {
  const selectedOption = props.options.find(option => option.value === newValue);
  internalSearchQuery.value = selectedOption?.label || '';
}, { immediate: true });

const filteredOptions = computed(() => {
  if (!internalSearchQuery.value || !props.filterable) {
    return props.options;
  }
  return props.options.filter((option) =>
    option.label.toLowerCase().includes(internalSearchQuery.value.toLowerCase())
  );
});

const onInput = (value: string) => {
  internalSearchQuery.value = value;
  open.value = true;
};

const selectOption = (option: Option) => {
  internalSearchQuery.value = option.label;
  emit('update:modelValue', option.value);
  open.value = false;
};

const closeDropdown = () => {
  open.value = false;
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(PadelInput, {
      value: internalSearchQuery.value,
      label: __props.label,
      onInput: onInput,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (open.value = true))
    }, null, 8, ["value", "label"]),
    (open.value && _unref(filteredOptions).length > 0)
      ? (_openBlock(), _createBlock("ul", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(filteredOptions), (option, index) => {
            return (_openBlock(), _createBlock("li", { key: index }, [
              _createVNode("button", {
                onClick: () => selectOption(option)
              }, _toDisplayString(option.label), 9, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_unref(vClickOutside), closeDropdown]
  ])
}
}

})